export default {
  props: {
    size: {
      default: "19"
    },
    fill: {
      default: "#22364C"
    }
  }
};